<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">DVR серверы</h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(tab, i) in tabs" :name="tab.key" :label="tab.name" :key="i">
          <component :is="tab.component" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import ServersList from "@/components/Servers/tabs/ServersList";
import ServersLogs from "@/components/Servers/tabs/ServersLogs";

export default {
  name: "Servers",
  data() {
    return {
      activeTab: "list",
      tabs: [
        {
          name: "Список",
          key: "list",
          component: ServersList,
        },
        {
          name: "Логи",
          key: "logs",
          component: ServersLogs,
        },
      ],
    };
  },
};
</script>
